import React from "react";
import { Tag, Row, Col } from "antd";
function InventoryShowComponent({ assetDetail, currency, crfSettingData }) {
	return (
		<div>
			<Row
				align='left'
				type='flex'
				justify='start'
				gutter={[0, 0]}
				style={{ padding: 0 }}
			>
				<Col span={8}>
					<span className='fs-10 '>Action&nbsp;</span>
					<Tag style={{ fontSize: "10px", display: "block", marginTop: "4px" }}>
						&nbsp;{assetDetail.action}
					</Tag>
				</Col>

				<Col span={8}>
					<span className='fs-10 '>Inv Status&nbsp;</span>
					<Tag style={{ fontSize: "10px", display: "block", marginTop: "4px" }}>
						&nbsp;{assetDetail.inventory_status}
					</Tag>
				</Col>

				{/* <Col span={8}>
				<span className='fs-10 '>
					<strong>
						Expected Expense ({crfSettingData?.data?.[0]?.crf_currency || "PKR"}
						)
					</strong>
					&nbsp;
				</span>
				<Tag style={{ fontSize: "10px", display: "block", marginTop: "4px" }}>
					&nbsp;
					{parseFloat(assetDetail.expected_expense)
						.toFixed(2)
						.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
				</Tag>
			</Col> */}

				{assetDetail?.serial_no && (
					<Col span={8}>
						<span className='fs-10 '>Serial No&nbsp;</span>
						<Tag
							style={{ fontSize: "10px", display: "block", marginTop: "4px" }}
						>
							&nbsp;{assetDetail.serial_no}
						</Tag>
					</Col>
				)}

				<Col span={8}>
					<span className='fs-10 '>Asset Code&nbsp;</span>
					<Tag style={{ fontSize: "10px", display: "block", marginTop: "4px" }}>
						&nbsp;{assetDetail.asset_code}
					</Tag>
				</Col>

				{/* <Col span={8}>
					<span className='fs-10 mb-10'>
						<strong>Expected Expense ({currency}) </strong>
					</span>
					<Tag style={{ fontSize: "10px", display: "block", marginTop: "4px" }}>
						{parseFloat(assetDetail.expected_expense_usd)
							.toFixed(2)
							.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
					</Tag>
				</Col> */}
				<Col span={8}>
					<span className='fs-10 mb-10'>
						Expected Expense{currency === "N/A" ? "" : ` (${currency})`}
					</span>

					<Tag style={{ fontSize: "10px", display: "block", marginTop: "4px" }}>
						{currency === "N/A"
							? "NA"
							: parseFloat(assetDetail.expected_expense_usd)
									.toFixed(2)
									.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
					</Tag>
				</Col>
				<Col span={8}>
					<span className='fs-10 '>Qty&nbsp;</span>
					<Tag style={{ fontSize: "10px", display: "block", marginTop: "4px" }}>
						{assetDetail.qty_inventory}
					</Tag>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<span>Remarks/Description&nbsp;</span>
					<Tag
						style={{
							fontSize: "10px",
							display: "block",
							marginTop: "4px",
							minHeight: "35px",
						}}
					>
						&nbsp;{assetDetail.description}
					</Tag>
				</Col>
			</Row>
		</div>
	);
}

export default InventoryShowComponent;
